import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { FrameworkProvider } from './context/up-api-provider/framework-context';

const OverviewPage = lazy(() => import('./pages/overview/overview.page'));
const ProductDetailPage = lazy(
  () => import('./pages/product-detail/product-detail.page'),
);
const NoAssessmentPage = lazy(
  () => import('./pages/no-assessment/no-assessment.page'),
);
const AssessmentListPage = lazy(
  () => import('./pages/assessment-list/assessment-list.page'),
);
const AssessmentHistoryPage = lazy(
  () => import('./pages/assessment-history/assessment-history.page'),
);
const QuickStartPage = lazy(
  () => import('./pages/quick-start/quick-start.page'),
);
const ManageAssessmentPage = lazy(
  () => import('./pages/manage-assessment/manage-assessment.page'),
);
const GroupDetailPage = lazy(
  () => import('./pages/group-detail/group-detail.page'),
);
const AssessmentHome = lazy(
  () => import('./pages/assessment-home/assessment-home'),
);
const InsurabilityDetailPage = lazy(
  () => import('./pages/insurability-detail/insurability-detail.page'),
);
export const CyberResilienceAssessmentRoutes = () => {
  return (
    <FrameworkProvider>
      <Routes>
        <Route>
          <Route index element={<AssessmentHome />}></Route>
          <Route index path=":assessmentId" element={<OverviewPage />}></Route>
          <Route
            index
            path=":assessmentId/products/:productId"
            element={<ProductDetailPage />}
          />
          <Route
            index
            path=":assessmentId/groups/:groupId"
            element={<GroupDetailPage />}
          />
          <Route
            index
            path=":assessmentId/insurability"
            element={<InsurabilityDetailPage />}
          />
          <Route index path="no-assessment" element={<NoAssessmentPage />} />
          <Route index path="list" element={<AssessmentListPage />} />
          <Route
            index
            path=":assessmentId/history"
            element={<AssessmentHistoryPage />}
          />
          <Route
            index
            path=":assessmentId/quick-start"
            element={<QuickStartPage />}
          />
          <Route
            index
            path=":assessmentId/manage-assessment"
            element={<ManageAssessmentPage />}
          />
        </Route>
      </Routes>
    </FrameworkProvider>
  );
};
